var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndustry({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 25,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clone page",
    clipPath: "url(#clip0_59_3)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 2944,
    transform: "translate(-120 -999)",
    fill: "#FFFBFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 52"
  }, /*#__PURE__*/React.createElement("g", {
    id: "inquiry author info"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -19.5,
    y: -122.5,
    width: 399,
    height: 474,
    rx: 19.5,
    stroke: "black",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 51"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    clipPath: "url(#clip1_59_3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.28713 0.5H2.77537C1.24505 0.5 0 1.74505 0 3.27537V8.78713C0 10.3175 1.24505 11.5625 2.77537 11.5625H8.28713C9.81745 11.5625 11.0625 10.3175 11.0625 8.78713V3.27537C11.0625 1.74505 9.81745 0.5 8.28713 0.5ZM9.1875 8.78713C9.1875 9.28358 8.78358 9.6875 8.28713 9.6875H2.77537C2.27892 9.6875 1.875 9.28358 1.875 8.78713V3.27537C1.875 2.77892 2.27892 2.375 2.77537 2.375H8.28713C8.78358 2.375 9.1875 2.77892 9.1875 3.27537V8.78713Z",
    fill: "#4D2481"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21.1875 0.5H15.75C14.1992 0.5 12.9375 1.76169 12.9375 3.3125V8.75C12.9375 10.3008 14.1992 11.5625 15.75 11.5625H21.1875C22.7383 11.5625 24 10.3008 24 8.75V3.3125C24 1.76169 22.7383 0.5 21.1875 0.5ZM22.125 8.75C22.125 9.26694 21.7044 9.6875 21.1875 9.6875H15.75C15.2331 9.6875 14.8125 9.26694 14.8125 8.75V3.3125C14.8125 2.79556 15.2331 2.375 15.75 2.375H21.1875C21.7044 2.375 22.125 2.79556 22.125 3.3125V8.75Z",
    fill: "#4D2481"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.28713 13.4375H2.77537C1.24505 13.4375 0 14.6825 0 16.2129V21.7246C0 23.255 1.24505 24.5 2.77537 24.5H8.28713C9.81745 24.5 11.0625 23.255 11.0625 21.7246V16.2129C11.0625 14.6825 9.81745 13.4375 8.28713 13.4375ZM9.1875 21.7246C9.1875 22.2211 8.78358 22.625 8.28713 22.625H2.77537C2.27892 22.625 1.875 22.2211 1.875 21.7246V16.2129C1.875 15.7164 2.27892 15.3125 2.77537 15.3125H8.28713C8.78358 15.3125 9.1875 15.7164 9.1875 16.2129V21.7246Z",
    fill: "#4D2481"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M21.1875 13.4375H15.75C14.1992 13.4375 12.9375 14.6992 12.9375 16.25V21.6875C12.9375 23.2383 14.1992 24.5 15.75 24.5H21.1875C22.7383 24.5 24 23.2383 24 21.6875V16.25C24 14.6992 22.7383 13.4375 21.1875 13.4375ZM22.125 21.6875C22.125 22.2044 21.7044 22.625 21.1875 22.625H15.75C15.2331 22.625 14.8125 22.2044 14.8125 21.6875V16.25C14.8125 15.7331 15.2331 15.3125 15.75 15.3125H21.1875C21.7044 15.3125 22.125 15.7331 22.125 16.25V21.6875Z",
    fill: "#4D2481"
  })))))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_59_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 2944,
    fill: "white",
    transform: "translate(-120 -999)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_59_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndustry);
export default __webpack_public_path__ + "static/media/industry.df596946ed5517622e3f35040edf09c9.svg";
export { ForwardRef as ReactComponent };